__turbopack_context__.v({
  "content": "Layout-module-scss-module__rGjB5a__content",
  "footer": "Layout-module-scss-module__rGjB5a__footer",
  "header": "Layout-module-scss-module__rGjB5a__header",
  "layout": "Layout-module-scss-module__rGjB5a__layout",
  "line-break": "Layout-module-scss-module__rGjB5a__line-break",
  "main": "Layout-module-scss-module__rGjB5a__main",
  "primary": "Layout-module-scss-module__rGjB5a__primary",
  "sidebar": "Layout-module-scss-module__rGjB5a__sidebar",
  "text-align_center": "Layout-module-scss-module__rGjB5a__text-align_center",
  "title": "Layout-module-scss-module__rGjB5a__title",
});
